import { render, staticRenderFns } from "./SendIcon.vue?vue&type=template&id=54e10556&scoped=true&"
import script from "./SendIcon.vue?vue&type=script&lang=js&"
export * from "./SendIcon.vue?vue&type=script&lang=js&"
import style0 from "./SendIcon.vue?vue&type=style&index=0&id=54e10556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e10556",
  null
  
)

export default component.exports